module.exports = __webpack_public_path__ + "img/collection-diamondJewelry070Carat.670d234.webp";